module.exports = __webpack_public_path__ + "static/shelter-4ead6740e77dc19e3bd03d90163ea11f.jpg";